<template>


    <div> 

        <v-dialog
        v-model="dialPhoto"
        :fullscreen="($vuetify.breakpoint.xs) ? true : false"
        width="70%"
        :retain-focus="false"
        @click:outside="closeDial"
        >
        <v-card>
        <v-card-text>
            <component v-bind:is="$modules.bibliotheque.components.client"
                :mod="mod"
                :idmodule="modulePhoto" 
                :modal="modal"
                :modalKey="modalKey"
                :customparams="{allowselect:true}"
                :page="page"
                :hook="hook"
                />
        </v-card-text>
        </v-card>
    </v-dialog>


        <FieldLabel v-if="prop.show" :label="item.name" :help="showFieldHelp ? fieldHelp : null" :field-id="item.id" :modal-key="modalKey" />
            <editor
            :id="editorId"
            tinymce-script-src="/tinymce/tinymce.min.js"
            v-model="model"
            :init="config"
            v-on:Onkeyup="keyup(item,model,false)"
            v-on:Onchange="keyup(item,model,false)"
            :key="key"
            />    

    </div> 
    </template>  
    
    
    
    <script>
    import mixinFields from '../../mixins/Fields'
    import mixinConditionsFields from '../../mixins/conditionsFields'
    import Editor from '@tinymce/tinymce-vue';

    import { getTinymce } from '@tinymce/tinymce-vue/lib/cjs/main/ts/TinyMCE';
    let textEditorSequence = 0

        export default {
            name : 'TextEditor',
    
            mixins : [mixinFields,mixinConditionsFields],
 
            components : {
                'editor': Editor
            },

            data: function() {
                return { 

                    editorId: `texteditor-${++textEditorSequence}`,

                    config : {
                        language: 'fr_FR',
                        height: 500,
                        menubar: true,
                        plugins: [
                        'preview', 'code', 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'anchor',
                        'searchreplace', 'visualblocks', 'fullscreen', 'media', 'table', 'insertdatetime', 'wordcount'
                        ],
                        toolbar: [
                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor',
                        'alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link image media table | removeformat searchreplace | code preview fullscreen'
                        ],
                        toolbar_mode: 'sliding',
                        // 🔸 Option essentielle pour éviter tout appel au CDN
                        base_url: '/tinymce', // si tu copies TinyMCE dans /public/tinymce (voir étape 3 ci-dessous)
                        suffix: '.min',
                        branding: false,
                        promotion: false,
                        content_style: 'body { font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; }'
                        },
                        firstload : true,
                        buttons : [],
                        dialPhoto : false,
                        modulePhoto : false,
                        key : 0,
                }
            },

            watch : {

                store() {
                    if(this.firstload) this.key++;
                },

                '$store.getters.getPicture': {
                    // permet de rafraichir l'encart de la photo après selection
                    handler(val) {

                        if (val && this.formThisField) {
                            
                            if(val.image_url) {
                            getTinymce().activeEditor.insertContent('<img src="'+val.image_url+'" width=30%>');
                            }
                            this.formThisField = false;
                            this.$store.dispatch('removePicture')
                            this.closeDial()
                        }

                    },
                    deep: true

                },

            },

            computed : {
                store() {
                    return this.mod;

                },

            },
    
            methods : {

                addbutton() {
                     
                    this.config.setup = (editor) => {
                        
                        this.item.otherparams.menueditor.forEach((elem,i) => {
                            editor.ui.registry.addMenuButton('button'+i, {
                            text: elem.namelist,
                            icon : elem.icon,
                            fetch: (callback) => {
                                var ee = [];
                                elem.list.forEach((link)=> {
                                    var item = {
                                        type: link.type,
                                        text : link.text,
                                        icon : link.icon,
                                        onAction:  () => {
                                            if(link.link) {
                                                this.modulePhoto = link.link
                                                this.dialPhoto = true
                                                this.formThisField = true
                                            } else {
                                                editor.insertContent(link.value);
                                            }
                                        
                                        }
                                    }
                                    ee.push(item);
                                })
                                callback(ee);
                            }
                        });
                        this.config.toolbar[1] = `${this.config.toolbar[1]} | button${i}`;
                        })

                    }

                    if(this.firstload) this.key++;
                },

                closeDial() {
                    this.dialPhoto = false
                    this.formThisField = false
                },


            },

            created() {
                this.addbutton()
                this.firstload = false
            }
    
        }
    
    </script>

    <style>
    div.tox-promotion { display:none; }
    .tox.tox-tinymce {
        overflow: hidden;
        border: 1px solid rgba(90, 98, 120, .28);
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(35, 43, 70, .08);
    }
    .tox .tox-editor-header {
        border-bottom: 1px solid rgba(90, 98, 120, .18) !important;
        box-shadow: none !important;
    }
    .tox .tox-toolbar-overlord,
    .tox .tox-toolbar__primary,
    .tox .tox-menubar {
        background-color: var(--app-toolbar, #fafbfe) !important;
        background-image: none !important;
    }
    .tox .tox-toolbar__group { padding: 0 5px !important; }
    .tox .tox-tbtn { border-radius: 5px !important; }
    .tox .tox-tbtn:hover { background: var(--app-tabs-active-background, #f0f1fa) !important; }
</style>
